import React, { useMemo, useContext, useEffect, useState, useCallback } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import Page from '../../../../layout/Page/Page';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import { demoPages } from '../../../../menu';
import { DefaultContext } from '../../../../contexts/default';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Button from '../../../../components/bootstrap/Button';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import SelectStore from '../../../../components/MyCustom/SelectStore';
import SelectDate from '../../../../components/MyCustom/SelectDate';
import useDarkMode from '../../../../hooks/useDarkMode';
import ClouserCashierDB from '../../../../database/wrappers/clouserCashier';
import Money from '../../../../helpers/utils/money/money';
import dateFormat from 'dateformat';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Label from '../../../../components/bootstrap/forms/Label';
import Input from '../../../../components/bootstrap/forms/Input';
import { orderBy, where } from 'firebase/firestore';
import RechargesDB from '../../../../database/wrappers/recharges';
import AppVersionDB from '../../../../database/wrappers/appVersion';

const Cashier = () => {

  const { darkModeStatus } = useDarkMode();

  const { establishment, store, onShowAlert } = useContext(DefaultContext)

  const [clouserCashiers, setclouserCashiers] = useState([])
  const [recharges, setRecharges] = useState([])
  const [dateOpen, setdateOpen] = useState(dateFormat(new Date(), 'yyyy-mm-dd'))
  const [dateFinish, setdateFinish] = useState(dateFormat(new Date(), 'yyyy-mm-dd'))
  const [appVersion, setappVersion] = useState({})


  useEffect(() => {
    new AppVersionDB()
      .get('com.uget_ticket_pdv')
      .then((version) => {
        setappVersion(version);
      })
      .catch((error) => {
        console.error("Erro ao buscar a versão do app:", error);
      });
  }, []);

  useEffect(() => {
    if (!establishment?.id || !store?.id || isNaN(new Date(dateOpen).getTime()) || isNaN(new Date(dateFinish).getTime())) return;

    const firstDate = new Date(dateOpen)
    firstDate.setDate(firstDate.getDate() + 1)
    firstDate.setHours(0, 0, 0);

    const secondDate = new Date(dateFinish)
    secondDate.setDate(secondDate.getDate() + 1)
    secondDate.setHours(23, 59, 59);

    const onSubscriber = new ClouserCashierDB(establishment.id, store.id).on(
      setclouserCashiers,
      where('opening_at', '>=', firstDate),
      where('opening_at', '<=', secondDate),
      orderBy('opening_at', 'desc')
    )
    return onSubscriber;
  }, [establishment, store, dateOpen, dateFinish])



  const calculateTotal = useCallback((row) => {
    if (!row) return 0;
    let total = row.cash || 0
      + row.debit || 0
      + row.credit || 0
      + row.pix || 0;
    if (row.meal_ticket)
      total += row.meal_ticket || 0
    return total;
  }, [])

  const calculateTotalPay = useCallback((row) => {
    return (row.cash_return
      - row.bleed || 0)
      + row.cash || 0
  }, [])

  const calculateDiffrence = useCallback((row) => {
    return calculateTotalPay(row) - row.paid;
  }, [calculateTotalPay])

  const onChangeDate = useCallback((e) => {
    const newDate = e.target.value;
    if (!isNaN(new Date(newDate).getTime())) {
      setdateOpen(newDate);
    }
  }, []);

  const onChangeSecondDate = useCallback((e) => {
    const newDate = e.target.value;
    if (!isNaN(new Date(newDate).getTime())) {
      setdateFinish(newDate);
    }
  }, []);

  const columns = useMemo(() => ([
    {
      label: 'Aberto',
      field: 'opening_at',
      format: row => row.opening_at ? dateFormat(row.opening_at.toDate(), 'dd/mm/yyyy HH:MM') : dateFormat(row.created_at.toDate(), 'dd/mm/yyyy HH:MM'),
      formatExport: row => row.opening_at || row.created_at,
      isDate: true
    },
    {
      label: 'Operador',
      field: 'operator',
    },
    {
      label: 'Terminal',
      field: 'terminal',
    },
    {
      label: 'Versão App',
      field: 'version',
      format: row => (
        <Button
          isLink
          color={row.version === appVersion.version ? 'success' : 'danger'}
          icon={row.version === appVersion.version ? 'Check' : 'ErrorOutline'}
          className='text-nowrap'
        >
          {row.version ?? 'Desatualizada'}
        </Button>
      ),
      formatExport: value => value,
    },
    {
      label: 'Status',
      field: 'closed',
      format: row => (
        <>
          <Button
            isLink
            color={row.closed ? 'danger' : 'success'}
            icon='Circle'
            // onClick={() => handleChangeStatus(row.id, row)}
            className='text-nowrap'>
            {row.closed ? 'Fechado' : 'Aberto'}
          </Button>
        </>
      ),
      formatExport: value => value ? 'Fechado' : 'Aberto',
    },
    {
      label: 'Troco',
      field: 'cash_return',
      format: row => Money.centsToMaskMoney(row.cash_return || 0),
      isCurrency: true
    },
    {
      label: 'Sangria',
      field: 'bleed',
      format: row => Money.centsToMaskMoney(row.bleed || 0),
      isCurrency: true
    },
    {
      label: 'Dinheiro',
      field: 'cash',
      format: row => Money.centsToMaskMoney(row.cash || 0),
      isCurrency: true
    },
    {
      label: 'Débito',
      field: 'debit',
      format: row => Money.centsToMaskMoney(row.debit || 0),
      isCurrency: true
    },
    {
      label: 'Crédito',
      field: 'credit',
      format: row => Money.centsToMaskMoney(row.credit || 0),
      isCurrency: true
    },
    {
      label: 'Cortesia',
      field: '{row}',
      format: row => row.courtesy !== undefined ? Money.centsToMaskMoney(row.courtesy) : Money.centsToMaskMoney(0),
      formatExport: row => row.courtesy !== undefined ? row.courtesy : 0,
      isCurrency: true
    },
    {
      label: 'Vale Refeição',
      field: '{row}',
      format: row => row.meal_ticket !== undefined ? Money.centsToMaskMoney(row.meal_ticket) : Money.centsToMaskMoney(0),
      formatExport: row => row.meal_ticket !== undefined ? row.meal_ticket : 0,
      isCurrency: true
    },
    {
      label: 'Pix',
      field: 'pix',
      format: row => Money.centsToMaskMoney(row.pix || 0),
      isCurrency: true
    },
    {
      label: 'Recarga Dinheiro',
      field: '{row}',
      format: row => row.payment_type === 2 ? Money.centsToMaskMoney(row.value || 0) : Money.centsToMaskMoney(0),
      formatExport: row => row.payment_type === 2 ? (row.value || 0) : 0,
      isCurrency: true
    },
    {
      label: 'Recarga Cartão',
      field: '{row}',
      format: row => row.payment_type !== 2 ? Money.centsToMaskMoney(row.value || 0) : Money.centsToMaskMoney(0),
      formatExport: row => row.payment_type !== 2 ? (row.value || 0) : 0,
      isCurrency: true
    },
    {
      label: 'Total',
      field: '{row}',
      format: row => Money.centsToMaskMoney(calculateTotal(row)),
      formatExport: row => calculateTotal(row),
      isCurrency: true
    },
    {
      label: 'A Pagar',
      field: '{row}',
      format: row => Money.centsToMaskMoney(calculateTotalPay(row)),
      formatExport: row => calculateTotalPay(row),
      isCurrency: true
    },
    {
      label: 'Pago',
      field: '{row}',
      format: row => row.closed ? Money.centsToMaskMoney(row.paid) : '',
      formatExport: row => row.closed ? row.paid : 0,
      isCurrency: true
    },
    {
      label: 'Diferença',
      field: '{row}',
      format: row => row.closed ? Money.centsToMaskMoney(calculateDiffrence(row)) : '',
      formatExport: row => row.closed ? calculateDiffrence(row) : 0,
      isCurrency: true
    },
  ]), [appVersion, calculateDiffrence, calculateTotal, calculateTotalPay])

  return (
    <>
      <PageWrapper title={demoPages.store.subMenu.cashier.text}>
        <SubHeader>
          <SubHeaderLeft>
            <Breadcrumb
              list={[
                { title: 'Loja', to: '/dashboard' },
                { title: 'Caixa', to: '/dashboard' },
              ]}
            />
          </SubHeaderLeft>
          <SubHeaderRight>

          </SubHeaderRight>
        </SubHeader>
        <Page container='fluid'>
          <Card>
            <CardBody className='table-responsive p-4'>
              <div className='row d-flex align-items-center' >
                <SelectEstablishment />
                <SelectStore />
              </div>
              <div className='row'>
                <div className='col-3'>
                  <FormGroup>
                    <Label htmlFor='period'>Data de Início</Label>
                    <Input
                      id='firstDate'
                      type='date'
                      ariaLabel='First Date'
                      placeholder='01/2021'
                      onChange={onChangeDate}
                      value={dateOpen}
                    />
                  </FormGroup>
                </div>

                <div className='col-3'>
                  <FormGroup>
                    <Label htmlFor='period'>Data de Fim</Label>
                    <Input
                      id='secondDate'
                      type='date'
                      ariaLabel='Second Date'
                      placeholder='01/2021'
                      onChange={onChangeSecondDate}
                      value={dateFinish}
                    />
                  </FormGroup>
                </div>

              </div>
              <TableCustom
                columns={columns}
                rows={[...clouserCashiers, ...recharges]}
                fileName={'Caixa'}
              />
            </CardBody>
          </Card>
        </Page>
      </PageWrapper>
    </>
  );
};

export default Cashier;
